import areas from './areas';
import cityTours from './cityTours';
import event from './event';
import favouriteRegions from './favouriteRegions';
import user from './user';
import searcher from './searcher';
import seeds from './seeds';
import photos from './photos';
import userPhotos from './userPhotos';
import unsplash from './unsplash';
import spots from './spots';
import translation from './translation';
import marketing from './marketing';
import moderationTelemetry from './moderationTelemetry';
import promises from './promises';
// import migration from './migration';
import notifications from './notifications';
import tips from './tips';
import openai from './openai';
import google from './google';
import autoModeration from './autoModeration';

const actions = {
  // migration
  areas,
  cityTours,
  event,
  favouriteRegions,
  user,
  searcher,
  seeds,
  photos,
  userPhotos,
  unsplash,
  spots,
  translation,
  marketing,
  moderationTelemetry,
  promises,
  notifications,
  tips,
  openai,
  google,
  autoModeration,
};

export default actions;
